// 예약 화면 단계 기록(UX/UI 1팀 10/17): 손님이 어느 고르기에서 멈추는지 세려고, 고를 때마다 작은 그림 파일(/img/bs.gif)을 한 번 부른다.
// 서버 접속 기록(lafia-api-detail.log)에 주소가 남는다. 보내는 것은 단계 이름(s), 화면 종류(v), 방문 무작위 번호(k)뿐이다(개인정보 없음).
// 방문 번호는 같은 탭에서 30분 동안 이어 쓴다: 결제하기 → 로그인 → 돌아온 손님이 두 방문으로 나뉘어 시간·상품 기록이 빠져 보이던 것(10/19)
// 세는 법: 웹개발팀 팀_UXUI 업무기록 20261017-1820-예약화면고치기\단계기록_SC01.js
const VISIT_KEY = "lafiaBookingVisit"
const VISIT_KEEP_MS = 30 * 60 * 1000
let visit = ""

export function startBookingVisit() {
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(VISIT_KEY) || "null")
    if (saved && saved.k && Date.now() - saved.at < VISIT_KEEP_MS) {
      visit = saved.k
    }
  } catch (error) {}
  if (!visit) visit = Math.random().toString(36).slice(2, 10)
  try {
    window.sessionStorage.setItem(VISIT_KEY, JSON.stringify({ k: visit, at: Date.now() }))
  } catch (error) {}
}

export function markBookingStep(step, screen) {
  try {
    if (!visit) startBookingVisit()
    const image = new Image()
    image.src = `/img/bs.gif?s=${encodeURIComponent(step)}&v=${encodeURIComponent(screen || "")}&k=${visit}&t=${Date.now()}`
  } catch (error) {}
}
